import React from "react";

const GoStatusCell = (props) => {
  const { dataItem } = props;

  return (
    <td
      className="roboto-15-400"
      style={
        dataItem.gostatus === "PRELIM"
          ? { background: "var(--color-prelim)", "font-weight": "700" }
          : { background: "transparent" }
      }
    >
      {dataItem.gostatus}
    </td>
  );
};

export { GoStatusCell };
